import { ajax, getJSON } from 'jquery'

export function destroy(url) {
  return ajax({
    method: 'DELETE',
    url,
  })
}

export function get(url, data) {
  return getJSON(url, data)
}

export function getSkipCache(url, data) {
  return ajax({
    method: 'GET',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(data),
    cache: false,
    url,
  })
}

export function patch(url, data) {
  return ajax({
    method: 'PATCH',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(data),
    url,
  })
}

export function post(url, data) {
  return ajax({
    method: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(data),
    url,
  })
}

export function put(url, data) {
  return ajax({
    method: 'PUT',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(data),
    url,
  })
}

// TODO: this is only exported so we can stub methods in tests. We should
//  1. Use an HTTP stubbing library like [Pretender](https://github.com/pretenderjs/pretender)
//  2. Change `import network from 'base/lib/network'` to
//     `import { … } from 'base/lib/network'`
//  3. remove this default export
export default {
  destroy,
  get,
  patch,
  post,
  put,
}
